// extracted by mini-css-extract-plugin
export default {"container":"HowToPlay_container__WCgdk","closeBtn":"HowToPlay_closeBtn__P7uiA"};